<div class="pdf-page app-aul-039-24" id="aul03724">
    <p class="font-large" style="text-align: center">
       <b> HEAT MAINTENANCE PROTECTIVE SAFEGUARDS</b>
    </p>
    <p class="font-large" style="text-align: center">
        <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
    </p>
    <br />
    <p class="font-small">
        This endorsement modifies insurance provided under the following:
        <br />
        COMMERCIAL PROPERTY COVERAGE PART 
    </p>
    <br>
    <p class="font-medium" style="text-align: center">
        <b>SCHEDULE</b>
    </p>
    <table
        style="border: 1px solid black; border-collapse: collapse; width: 100%"
    >        <thead>
            <tr>
                <th style="text-align: center; border: 1px solid black; padding: 5px">
                    Premises No.
                </th>
                <th style="text-align: center; border: 1px solid black; padding: 5px">
                    Bldg No.
                </th>
                <th style="text-align: center; border: 1px solid black; padding: 5px">
                    Protective Safeguards Symbols Applicable
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style="text-align: center; padding: 5px">All Covered Premises as described in the Declarations</td>
                <td style="text-align: center; padding: 5px">All Covered Buildings as described in the Declarations</td>
                <td style="text-align: center; padding: 5px"><b>“HM-1” OR “HM-2”</b></td>
            </tr>
        </tbody>
    </table>
    <br>
    <ol type="A" start="1">
    <li>
        <p>The following is added to the:</p>
        <p>Commercial Property Conditions</p>
        <p>
            <b>Heat Maintenance Protective Safeguards</b>
        </p>
        <p>As a condition of this insurance, you are required to:</p>
        <ol style="padding-left: 35px;">
            <li style="padding-bottom: 5px;">Maintain the protective safeguards listed in the Schedule, and over which you have control, in complete working order;</li>
            <li style="padding-bottom: 5px;">Notify us if you know of any suspension of or impairment in any protective safeguard listed in the Schedule.</li>
        </ol>
    </li>
    <li>
        <p class="font-small">The following is added to the EXCLUSIONS section of:</p>
        <p class="font-small bold">CAUSES OF LOSS – SPECIAL FORM</p>
        <p>The following <b>Water Damage Exclusion</b> is added <b>B. Exclusions:</b></p>
        <p><b>Water Damage</b></p>
        <ul style="list-style-type: none">
        <li style="padding-bottom: 5px;">
            a.  We will not pay for loss or damage caused by or resulting from Water Damage if, prior to the loss or damage, you failed to comply with any condition set forth in Paragraph <b>A</b>.
        </li>
        <li style="padding-bottom: 5px;">
            b.  <b>Water Damage</b>, meaning accidental discharge or leakage of water or steam as the direct result of the breaking apart or cracking of a plumbing, heating, air conditioning or other system or appliance, that is located on the described premises and contains water or steam.
        </li>
        <p>This Water Damage Exclusion also excludes loss or damage from:</p>
        <!-- <ol type="1" style="padding-left: 35px;"> -->
            <ul style="list-style-type: none">
                <li style="padding-bottom: 5px;">
                    (1) Discharge or leakage from:
                    <ul style="list-style-type: none">
                        <li style="padding-bottom: 5px;">
                            <b>(a)</b> An Automatic Sprinkler System;
                        </li>
                        <li  style="padding-bottom: 5px;">
                            <b>(b)</b> A sump or related equipment and parts, including overflow due to sump pump failure or excessive volume of water; or
                        </li>
                        <li style="padding-bottom: 5px;">
                            <b>(c)</b> Roof drains, gutters, downspouts or similar fixtures or equipment.
                        </li>
                    </ul>
                </li>
                <li style="padding-bottom: 5px;">
                    (2) The cost to repair any defect that caused the loss or damage;
                </li>
                <li style="padding-bottom: 5px;">
                    (3) Loss or damage caused by or resulting from continuous or repeated seepage or leakage of water, or the presence or condensation of humidity, moisture or vapor, that occurs over a period of 14 days or more; or
                </li>
                <li style="padding-bottom: 5px;">
                    (4) Loss or damage caused by or resulting from freezing.
                </li>
        </ul>
        <li style="padding-bottom: 5px;">
            c.  If the building or structure containing the system or appliance is Covered Property, we will not pay the cost to tear out and replace any part of the building or structure to repair damage to the system or appliance from which the water or steam escapes and we will not pay the cost to repair any defect that caused the loss or damage.
        </li>
        </ul>
        <br>  
</li>

</ol>
    
</div>
<div class="pdf-page app-aul-039-24">
    <ol type="A" start="3">
    <li>  
        <p>The protective safeguards to which this endorsement applies are identified by the following symbols or as described in Your submission and/or application:</p>
        <ul style="list-style-type: none">
            <li style="padding-bottom: 5px;">
                1. <b>“HM-1” Ambient Temperature</b>, Maintain an ambient temperature of not less than 55 degrees Fahrenheit at all times throughout the buildings identified in the schedule by use of a gas-fired, electric or similar heating system.
            </li>
            <li style="padding-bottom: 5px;">
                2. "HM-2" Water Supply Shut Off and Draining systems. Where an ambient temperature is not maintained as defined in “HM-1”, all plumbing systems must have the water supply shut off and all service and pipework completely drained.
            </li>   
        </ul> 
    </li>    
</ol>
<p><b>All other terms and conditions of this policy remain unchanged.</b></p>
</div>